const dataStructure = { ids: [], byId: {} };

const formatArray = (acc, next) => {
    acc.ids = acc.ids.concat(next._id);
    acc.byId[next._id] = next;
    return acc;
};

const formatData = (data) => {
    // Check if data contains paginated results
    const results = Array.isArray(data?.results) ? data.results : data;

    // Ensure the results is an array before reducing
    if (!Array.isArray(results)) {
        console.error('formatData expects an array, but received:', typeof results);
        return { ids: [], byId: {} };
    }

    return results.reduce(formatArray, { ids: [], byId: {} });
};

const countriesOptionLabel = (option) => `${option.alpha2Code} ${option.name}`;

export { formatData, dataStructure, countriesOptionLabel };
